import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const POINTS = [
  ["No drawings, no chance", "Your place is set only by when you joined and stayed paid."],
  ["Trips are not guaranteed", "Wait times are estimates and depend on how many members join and stay paid."],
  ["You may fund your own trip", "If sign-ups slow or stop, your own payments plus what's in the fund may be what pays for your trip."],
  ["Miss a payment, lose your spot", "If your paid period ends, you leave the line. Rejoining starts you at the back."],
  ["Cancel anytime", "Membership fees are non-refundable once your 30-day period starts."],
  ["Accept, pass or donate", "At #001 you have 7 days to choose; otherwise the trip is accepted for you. Trips have no cash value."],
  ["Buy it now", "Pay the rest of your trip cost plus a 10% fee and go right away. Non-refundable."],
  ["Giving", "Optional monthly gifts are processed by the Pledgeling Foundation, a 501(c)(3), and passed to the school or fund you pick. See our Mission page for how the club gives."],
  ["We're an intermediary", "VoyageQueue runs the membership and trip funds. Flights, hotels, tours and tickets come from independent providers under their own terms."],
  ["Our software is protected", "Our app, code, algorithms and content are our property and trade secrets. No copying, scraping, reverse engineering or bots."],
  ["Who can join", "18+ US residents only. Not currently available in California, Florida, Hawaii or Washington."],
];

export const TermsSummary = () => (
  <section data-testid="terms-summary-section" className="border-t border-white/10 bg-[#0B0F19]/60">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow"><ShieldCheck className="w-3.5 h-3.5 mr-1.5" />Terms & conditions · the short version</p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl mt-4">Know exactly what you're joining</h2>
        </div>
        <Link to="/terms" data-testid="terms-summary-full-link" className="btn-ghost px-6 py-3 text-sm">Read the full terms</Link>
      </div>
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-7">
        {POINTS.map(([h, t], i) => (
          <div key={h} data-testid={`terms-point-${i}`}>
            <p className="font-semibold text-sm text-white">{h}</p>
            <p className="text-sm text-slate-400 mt-1 leading-relaxed">{t}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
